import TRANSLATIONS from "./user.alert.translations";
import TYPE from "./alert.types";

export default {
    noFreeSlots: {
        type: TYPE.WARNING,
        translation: TRANSLATIONS.NO_FREE_SLOTS,
        linkTranslation: TRANSLATIONS.INCREASE_NOW_LINK,
        linkPermission: "CHANGE_BILLING_PERMISSION"
    },
    oneFreeSlot: {
        type: TYPE.INFO,
        translation: TRANSLATIONS.ONE_FREE_SEAT,
        linkTranslation: TRANSLATIONS.CHANGE_PLAN_LINK,
        permission: "CHANGE_BILLING_PERMISSION"

    },
    manyFreeSlots: {
        type: TYPE.SUCCESS,
        translation: TRANSLATIONS.MANY_FREE_SEATS,
        linkTranslation: TRANSLATIONS.CHANGE_PLAN_LINK,
        permission: "CHANGE_BILLING_PERMISSION"

    },
    changePlanPending: {
        type: TYPE.WARNING,
        translation: TRANSLATIONS.CHANGE_PLAN_PENDING,
        hideDelete: true

    },
    changePlanSuccess: {
        type: TYPE.SUCCESS,
        translation:
        TRANSLATIONS.CHANGE_PLAN_SUCCESS_LABEL,
        permission: "CHANGE_BILLING_PERMISSION"

    },
    invitationSuccess: {
        type: TYPE.SUCCESS,
        translation: TRANSLATIONS.INVITATION_SUCCESS_LABEL,
        permission: "CHANGE_BILLING_PERMISSION"
    }
};
